import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import MergeOutlinedSvg from "@ant-design/icons-svg/es/asn/MergeOutlined";
import AntdIcon from "../components/AntdIcon";
var MergeOutlined = function MergeOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: MergeOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  MergeOutlined.displayName = 'MergeOutlined';
}
export default /*#__PURE__*/React.forwardRef(MergeOutlined);